import userApiService from "@/services/userApiService"
import store from "@/store/store";

export default ({
    state: {
      id: "",
      username: "",
      email: "",
      phone: "",
      passphrase: "",
      status: ""
    },
    mutations: {
      SET_USER_ID(state, value) {
        if(value) {
            state.id = value
        } else {
            state.id = ""
        }
      },
      SET_USER_USERNAME(state, value) {
        if(value) {
            state.username = value
        } else {
            state.username = ""
        }
      },
      SET_USER_EMAIL(state, value) {
        if(value) {
            state.email = value
        } else {
            state.email = ""
        }
      },
      SET_USER_PHONE(state, value) {
        if(value) {
          console.log("Setting VALUE:", value)
            state.phone = value
        } else {
          console.log("SETTING EMPTY STRING")
            state.phone = ""
        }
      },
      SET_USER_PASSPHRASE(state, value) {
        if(value) {
            state.passphrase = value
        } else {
            state.passphrase = ""
        }
      },
      SET_USER_STATUS(state, value) {
        if(value) {
            state.status = value
        } else {
            state.status = ""
        }
      },
    },
    actions: {
      setSelectedUser({ commit }, user) {
        if(user) {
          commit('SET_USER_ID', user.userId)
          commit('SET_USER_USERNAME', user.userName)
          commit('SET_USER_EMAIL', user.email)
          commit('SET_USER_PHONE', user.phoneNumber)
          commit('SET_USER_PASSPHRASE', user.passphrase)
          commit('SET_USER_STATUS', user.status)
        } else {
          commit('SET_USER_ID', "")
          commit('SET_USER_USERNAME', "")
          commit('SET_USER_EMAIL', "")
          commit('SET_USER_PHONE', "")
          commit('SET_USER_PASSPHRASE', "")
          commit('SET_USER_STATUS', "")
        }
      },
      async reloadSelectedUserFromApi({commit}) {
        if(!store.getters.getIsLoggedIn) {
          return
        }
        await userApiService.getUser(store.getters.getSelectedUserId).then(result => {
          commit('SET_USER_ID', result.userId)
          commit('SET_USER_USERNAME', result.userName)
          commit('SET_USER_EMAIL', result.email)
          commit('SET_USER_PHONE', result.phoneNumber)
          commit('SET_USER_PASSPHRASE', result.passphrase)
          commit('SET_USER_STATUS', result.status)
        }, error => {
          console.error(error);
        });
      }
      
    },
    getters: {
      getSelectedUserId(state) {
        return state.id;
      },
      getSelectedUserName(state) {
        return state.username;
      },
      getSelectedUserEmail(state) {
        return state.email;
      },
      getSelectedUserPhone(state) {
        return state.phone;
      },
      getSelectedUserPassphrase(state) {
        return state.passphrase;
      },
      getSelectedUserStatus(state) {
        return state.status;
      },
    }
})